export const ANIMATION_PERCENTAGE = {
  text: 0.4,
};
